export enum OutgoingInvoiceStatus {
    Draft = 'Draft',
    Approved = 'Approved',
    Sent = 'Sent',
    Paid = 'Paid',
    Archived = 'Archived',
}
